<template>
  <div class="container-custom">
    <Breadscrumbs
      :links="[
        { name: 'Investor FAQ',
          to: {
            name: 'InvestorFAQList'
          }
        },
        { name: 'Create',
          to: {
            name: 'InvestorFAQCreate',
          },
        },
      ]"
    ></Breadscrumbs>
    <div class="page-actions">
      <h2>新增Investor FAQ</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        取消
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        儲存
      </button>
    </div>
    <InvestorFAQCreateEdit></InvestorFAQCreateEdit>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import InvestorFAQCreateEdit from '@/views/I-1__IR-InvestorFAQ/c/InvestorFAQCreateEdit.vue';

export default {
  components: {
    Breadscrumbs,
    InvestorFAQCreateEdit,
  },
  data: () => ({
    isLangOpen: false,
  }),
  created() {
    this.setShareholderFaq({});
  },
  computed: {
    ...mapState('shareholderFaq', ['shareholderFaq']),
  },
  methods: {
    ...mapActions('shareholderFaq', ['setShareholderFaq', 'save']),
    cancelHandler() {
      this.$router.push({ name: 'InvestorFAQList' });
    },
    saveHandler() {
      this.save(this.shareholderFaq).then(() => {
        this.$router.push({ name: 'InvestorFAQList' });
      });
    },
  },
};
</script>

<style></style>
